import React, { useState } from "react";
import KC_Modal_2 from "../../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading4 from "../../../../designsystem/typography/KC-Heading/KC_Heading4";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import KC_Button from "../../../../designsystem/KC_Button/KC_Button";
import { tt } from "../../../../utils/i18n/i18n";
import {
  useAccountToDisplaySelector,
  updateCustomerThunk
} from "../../../../redux/actions/user";
import "../../styles.scss";
import CurrencyProp from "../model/CurrencyProp";
import { useDispatch } from "react-redux";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  currentAvgBasket?: number;
  currency?: CurrencyProp;
}

export default function AvgBasketModal(props: Props) {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const [avgBasket, setAvgBasket] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateAvgBasket = async () => {
    if (!accountToDisplay?.token || !accountToDisplay.trackingID) {
      return;
    }

    setIsLoading(true);

    try {
      dispatch(
        updateCustomerThunk(
          { avgBasket },
          accountToDisplay.trackingID,
          accountToDisplay.token
        )
      );

      props.onClose();
    } catch (error) {
      console.error("Error updating avgBasket:", error);
      alert(tt("api_error"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <KC_Modal_2
      id="change-avg-basket-modal"
      isOpen={props.isOpen}
      onClose={props.onClose}
      header={<KC_Heading4 text={tt("modify_avg_basket_modal_title")} />}
      footer={
        <div className="w-100 d-flex justify-content-center st-gap">
          <KC_Button
            text={tt("cancel")}
            size="lg"
            onClick={props.onClose}
            isPrimary={false}
            isInverted={true}
            extraStyle={{
              width: "unset !important"
            }}
          />
          <KC_Button
            text={tt("save")}
            size="lg"
            onClick={handleUpdateAvgBasket}
            isPrimary={true}
            disabled={isLoading || !avgBasket}
            extraStyle={{
              width: "unset !important"
            }}
          />
        </div>
      }
    >
      <div className="d-flex flex-column mt-4 px-4 st-gap">
        <KC_UIText
          weight="reg"
          text={tt("modify_avg_basket_modal_description", {
            currency: props.currency?.trigram
          })}
        />
        <input
          type="number"
          className="form-control"
          value={avgBasket}
          onChange={(e) => setAvgBasket(e.target.valueAsNumber)}
          step={1}
          placeholder={tt("modify_avg_basket_modal_input_placeholder")}
        />
        <KC_UIText
          weight="reg"
          text={tt("modify_avg_basket_modal_helper_text")}
          className="mb-4"
        />
      </div>
    </KC_Modal_2>
  );
}
